export const ROUBLE_SIGN = '\u20BD';
export const ROUBLE_PER_MONTH_SIGN = '\u20BD/мес';
export const ROUBLE_PER_DAY_SIGN = '\u20BD/сут.';
